import { render, staticRenderFns } from "./Ocr.vue?vue&type=template&id=329d0017&scoped=true"
import script from "./Ocr.vue?vue&type=script&lang=js"
export * from "./Ocr.vue?vue&type=script&lang=js"
import style0 from "./Ocr.vue?vue&type=style&index=0&id=329d0017&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329d0017",
  null
  
)

export default component.exports